import { Component, inject, input, OnDestroy, output, signal } from '@angular/core';
import { TableChartComponent } from '../table-chart/table-chart.component';
import { TableChart } from 'src/app/types/table-chart';
import { ChartService } from 'src/app/services/chart/chart.service';
import { BaseComponent } from 'src/app/components/_base/base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isChart } from 'src/app/shared/utils';
import { TranslatePipe, TranslateService, _ } from '@ngx-translate/core';
import { captureException } from '@sentry/angular';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './table-chart.component.html',
  standalone: true,
  selector: 'app-onboarding-table-chart',
  imports: [TableChartComponent, MatButtonModule, TranslatePipe],
})
export class OnboardingTableChartComponent extends BaseComponent implements OnDestroy {
  private readonly chartService = inject(ChartService);
  private readonly snackbar = inject(MatSnackBar);
  private readonly translate = inject(TranslateService);

  readonly chart = input.required<TableChart>();

  readonly loading = signal(false);

  readonly back = output<void>();
  readonly continue = output<void>();

  onContinue() {
    const chart = this.chartService.chart as TableChart | undefined;

    if (!chart || isChart(chart)) return;

    this.loading.set(true);

    this.sub$ = this.chartService
      .updateTableChart(chart._id, {
        published: chart.published,
        matching: chart.matching,
        blocks: chart.blocks,
        tableData: chart.tableData,
        name: chart.name,
        heroImage: chart.heroImage,
        heroText: chart.heroText,
        tableFreeze: chart.tableFreeze,
        howToMeasure: chart.howToMeasure,
        showUnitConversion: chart.showUnitConversion,
        sizeRecommender: chart.sizeRecommender,
      })
      .subscribe({
        next: () => {
          this.loading.set(false);
          this.continue.emit();
        },
        error: (error) => {
          captureException(error);
          this.loading.set(false);
          this.snackbar.open(
            this.translate.instant(_('error.error-occured')),
            this.translate.instant(_('common.close')),
            { panelClass: 'snackbar-error' },
          );
        },
      });
  }

  override ngOnDestroy() {
    this.chartService.chart = undefined;

    super.ngOnDestroy();
  }
}
